<div class="bg-img pt-5">
    <div>
        <img class="Xemplar-log ml-0" src="../../../../assets/images/bay6-logo_white.svg">
    </div>
    <div class="row login-container">
        <div class="col-md-6 col-md-6 login-container-grid">
            <img class="login-container-img" src="../../../../assets/images/laptop03-min.png">
        </div>
        <div class="col-lg-6 col-md-6 login-container-grid">
            <div class="login-board">
                <div class="text-center">
                    <img class="img-fluid mhub-logo-login" src="../../../../assets/images/Model6_white.png"
                        width="10px">
                </div>
                <div class="login-title">
                    <h4>Welcome to Customer Portal<span class="login_text">(v3.0)</span></h4>
                    
                </div>
                <div class="row col-sm-12 p-0 m-0">
                    <div class="col-sm-12">
                        <div class="login-container-form">
                            <form [formGroup]="loginForm" autocomplete="off">
                                <div class="form-group">
                                    <div class="input-group mb-4" id="wrap">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <img src="../../../../assets/images/mail_icon.svg"
                                                    class="img-responsive placehold-email-img" alt="email"
                                                    width="16px;" />
                                            </span>
                                        </div>
                                        <input autocomplete="off" id="email" type="email" placeholder="Email*"
                                            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,3}$"
                                            formControlName="userName" class="form-control" maxlength="100"
                                            
                                             />
                                             @if(loginForm.get('userName')!.touched && loginForm.get('userName')!.errors){
                                            <div  class="invalid-feedback mt-2" style="font-size: 14px;font-weight: 700;">
                                                @if(loginForm.get('userName')!.errors?.['required']){
                                                <div>
                                                    Email ID is required.
                                                </div>
                                            }
                                            @if(loginForm.get('userName')!.errors?.['email']){
                                                <div >
                                                    Not a valid Email ID.
                                                </div>
                                            }
                                            </div>
                                        }
                                      
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                           
                                            <span class="input-group-text" id="basic-addon1">
                                                <img src="../../../../assets/images/password_icon.svg"
                                                    class="img-responsive placehold-email-img" alt="email"
                                                    width="16px;" />
                                            </span>
                                        </div>
                                        <input autocomplete="off" id="password" placeholder="Password*"
                                             formControlName="password"  [type]="showPassword ? 'text' : 'password'"
                                            class="form-control" maxlength="20" style="border-radius:0px !important"
                                            (keydown.space)="$event.preventDefault()" 
                                          />
                                            <div  class="invalid-feedback mt-2" style="font-size: 14px;font-weight: 700;">
                                                @if((loginForm.get('password')?.touched || loginForm.get('password')?.dirty) && loginForm.get('password')!.errors?.['required']){
                                                <div style="font-weight: 700;">
                                                    Password is required.
                                                </div>
                                            }
                                            </div>
                                        <div class="input-group-text" (click)="togglePassword()">
                                            <span class="input-group-text"
                                                style="border-top-right-radius: 8px !important; border-bottom-right-radius: 8px !important;border: none;cursor: pointer;">
                                             @if(!showPassword){
                                                <img  src="../../../assets/images/eye_ic.svg">
                                             }
                                            @if( showPassword){
                                               <img  src="../../../assets/images/eye_close_ic.svg">
                                            }
                                                 
                                            </span>
                                        </div>
                                      
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-submit" (click)="login()" [disabled]="loginForm.invalid"
                                    >Sign In</button>
                            </form>
                            <h4 class="forgot-password"><a href="javascript:void(0)" (click)="openForgotPassword(forgotPassword)"
                                    >
                                    Forgot / Change Password?
                                </a></h4>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
   
    <div class="copyright">
        <span>Powered by Bay6.ai, Inc. | Version 3.0</span>
        <p>Copyright © {{currentYear}} All Rights Reserved</p>
    </div>
</div>

<ng-template #forgotPassword let-modal>
    <div class="modal-header">
        <span class="modal-title ml-0 pl-0" id="modal-basic-title">Forgot Password</span>
        <img src="assets/images/close_icon.svg" style="width:20px; height:20px; cursor:pointer" alt
            (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="modal-body">
        <!-- <app-forgot-password></app-forgot-password> -->
         <form [formGroup]="confirmEmailForm" autocomplete="off">
    <div class="isave-logo text-center mb-1">
        <img class="img-fluid" src="assets/images/Model6_logo.png" width="183px" height="50px" />
    </div>
    <div class="form-group mb-2">
        <label>Email<span class="required">*</span>
        </label>
        <div class="input-group mb-3">
         
            <input type="text" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,3}$" formControlName="emailId"
                class="form-control" maxlength="100" placeholder="Enter your Registered Email"
               style="height: 40px; width: 300px;"
                (keydown.space)="$event.preventDefault()">
        
        </div>
       
           @if((confirmEmailForm.get('emailId')?.touched || confirmEmailForm.get('emailId')?.dirty) && confirmEmailForm.get('emailId')?.errors?.['required']) {
                                                <div class="invalid-feedback" style="margin-top: -19px;">
                                                    Email ID is required.
                                                </div>
                                            }
                                             @if(confirmEmailForm.get('emailId')!.errors?.['email']){
                                                <div class="invalid-feedback" style="margin-top: -19px;">
                                                    Not a valid Email ID.
                                                </div>
                                            }
    </div>

    <div class="d-flex justify-content-center">
        <button type="button" [disabled]="!confirmEmailForm.valid" class="btn btn-form-submit"
            (click)="forgotPasswordModel()">Submit</button>
    </div>
</form>
    </div>
</ng-template>

<ng-template #changesPassword let-modal>
    <div class="modal-header">
        <span class="modal-title ml-0 pl-0" id="modal-basic-title">Reset Your Password</span>
        <img src="assets/images/close_icon.svg" style="width:20px; height:20px; cursor:pointer" alt
            (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="modal-body  reset-password">
       <form class="row" [formGroup]="changePasswordForm">
        @for(field of forgetPassword_fields;track field){
        <div [class]="field.column" style="    margin-bottom: -10px;">
            <app-dynamic-form-builder  [field]="field"  
                [form]="changePasswordForm"></app-dynamic-form-builder>
        </div>
        }
    </form>
        <div class="row">
                <div class="col-sm-12">
                    <div class="d-flex justify-content-center w-100 mt-3">
                        <button type="button" class="btn btn-form-submit-cancel model_btn_width" (click)="cancelBtnResetPwd()"
                            >Cancel</button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button" class="btn btn-form-submit ml-2" (click)="resetPassword()"
                            [disabled]="!changePasswordForm.valid" ngbAutofocus> Reset Password
                        </button>
                    </div>
                </div>
            </div>
    </div>
</ng-template>
<app-alert-dialog id="LC1" #alert>
     <span class="header">Login Error</span>
    <span class="message">{{loginErrorMsg}}</span>
</app-alert-dialog>